<template>
  <span>
        <v-navigation-drawer
            v-model="drawer"
            color="white darken-2"
            disable-resize-watcher="true"
        >
            <v-list>
                <v-list-item
                    v-show="isAuthorized"
                    :to="profileRedirectionLink"
                    :active="false"
                >
                  <template v-slot:prepend>
                    <v-icon
                        color="black"
                        icon="mdi-account-circle"
                    />
                  </template>
                  <p>{{ username }}</p>
                  <p
                      v-if="accountStatistics.length > 0"
                  >
                    <span
                        v-for="(balance, index) in accountStatistics"
                        :key="balance"
                    >
                      {{
                        balance
                      }}
                      <span v-if="index !== accountStatistics.length - 1"> </span>
                    </span>
                  </p>
                </v-list-item>
                <v-list-item
                    v-if="!isAuthorized"
                    :to="signInRedirectionLink"
                    :active="false"
                >
                  <template v-slot:prepend>
                    <v-icon
                        color="black"
                        icon="mdi-login"
                    />
                  </template>
                  <p>Sign In</p>
                </v-list-item>
                <v-divider v-show="!isAuthorized"/>
                <v-list-item
                    v-show="!isAuthorized"
                    :to="signUpRedirectionLink"
                    :active="false"
                >
                  <template v-slot:prepend>
                    <v-icon
                        color="black"
                        icon="mdi-account-plus"
                    />
                  </template>
                  <p>Sign Up</p>
                </v-list-item>
                <v-divider/>
                <template
                    v-for="(item, index) in visibleMainMenuItems"
                    :key="index"
                >
                    <v-list-item
                        :to="item.to"
                        :active="false"
                    >
                      <template v-slot:prepend>
                        <v-icon
                            :icon="item.icon"
                            color="black"
                        />
                      </template>
                      <p>{{ item.title }}</p>
                    </v-list-item>
                    <v-divider></v-divider>
                </template>
                <v-list-item
                    v-show="isAuthorized"
                    :to="profileRedirectionLink"
                    :active="false"
                    @click="this.signOut"
                >
                  <template v-slot:prepend>
                    <v-icon
                        color="black"
                        icon="mdi-logout"
                    />
                  </template>
                  <p>Sign Out</p>
                </v-list-item>
            </v-list>
        </v-navigation-drawer>
        <v-toolbar
            color="black darken-4"
            app
            dark>
          <v-row
              justify="center"
              no-gutters="true"
          >
            <v-col
                cols="12"
                md="3"
                align-self="center"
            >
              <v-row no-gutters="true">
                <v-app-bar-nav-icon
                    class="hidden-md-and-up"
                    @click="drawer = !drawer"
                />
                <v-toolbar-title class="pl-md-3 my-auto">
                  <v-icon
                      color="yellow"
                      icon="mdi-rhombus"
                  />
                  {{ appTitle }}
                </v-toolbar-title>
              </v-row>
            </v-col>
            <v-col
                v-show="$vuetify.display.mdAndUp"
                cols="9"
            >
              <v-row no-gutters="true">
                <v-col
                    cols="8"
                    align-self="center"
                >
                  <v-row
                      no-gutters="true"
                      justify="center"
                  >
                    <v-btn
                        v-for="(item, index) in visibleMainMenuItems"
                        :key="index"
                        :to="item.to"
                    >
                      {{ item.title }}
                    </v-btn>
                  </v-row>
                </v-col>
                <v-col
                    v-if="!isAuthorized"
                    cols="4"
                    class="pr-3"
                    align-self="end"
                >
                  <v-row
                      justify="end"
                      no-gutters="true"
                  >
                    <v-btn
                        :to="signInRedirectionLink"
                        class="hidden-sm-and-down mx-1"
                        flat="true"
                    >
                      SIGN IN
                    </v-btn>
                    <v-btn
                        :to="signUpRedirectionLink"
                        class="hidden-sm-and-down mx-1"
                        color="white"
                        variant="outlined"
                    >
                      SIGN UP
                    </v-btn>
                  </v-row>
                </v-col>
                <v-col
                    v-if="isAuthorized"
                    cols="4"
                    class="pr-3 my-auto"
                >
                  <v-row justify="end">
                    <v-col>
                      <v-menu>
                        <template v-slot:activator="{ props }">
                            <v-row no-gutters="true" justify="end" align-content="end">
                              <v-spacer/>
                              <v-col>
                                  <v-btn
                                      :text="username"
                                      v-bind="props"
                                      class="mx-3 text-none"
                                      color="white"
                                      prepend-icon="mdi-account-circle"
                                      variant="text"
                                  />
                                  <p
                                      v-if="accountStatistics.length > 0"
                                      class="ml-2 pl-4"
                                  >
                                    <span
                                        v-for="(balance, index) in accountStatistics"
                                        :key="balance"
                                    >
                                      {{
                                        balance
                                      }}
                                      <span v-if="index !== accountStatistics.length - 1">/</span>
                                    </span>
                                  </p>
                              </v-col>
                            </v-row>
                        </template>
                        <v-list>
                          <v-list-item
                              v-for="(item, index) in profileItems"
                              :key="index"
                              :prepend-icon="item.icon"
                              :title="item.title"
                              :to="item.to"
                              :value="index"
                              @click="item.onClick"
                          />
                        </v-list>
                      </v-menu>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </v-toolbar>
    </span>
</template>

<script>

import {inject, readonly} from "vue";
import {auth} from "@/common/auth";
import {router} from "@/router";
import {api} from "@/common/api";
import {numbers} from "@/common/numbers";

export default {
  name: 'TheHeader',
  data() {
    return {
      signInRedirectionLink: readonly({
        name: 'sign-in'
      }),
      signUpRedirectionLink: readonly({
        name: 'sign-up'
      }),
      profileRedirectionLink: readonly({
        name: 'profile',
        hash: '#profile'
      }),
      appTitle: 'MainroadTrade',
      drawer: false,
      mainMenuItems: [
        {title: 'Cars', icon: 'mdi-car-estate', to: {name: 'home'}, roles: ['ALL']},
        {
          title: 'Orders',
          icon: 'mdi-car-multiple',
          to: {name: 'profile', hash: '#orders'},
          roles: ['ROLE_CONFIRMED_USER']
        },
        {
          title: 'Client orders',
          icon: 'mdi-car-multiple',
          to: {name: 'admin-car-requests-view'},
          roles: ['ROLE_MANAGER', 'ROLE_ADMIN']
        },
        {
          title: 'Accountant',
          icon: 'mdi-account-cash',
          to: {name: 'accountant-clients-view'},
          roles: ['ROLE_ADMIN']
        },
        {title: 'Export guide', icon: 'mdi-ferry', to: {name: 'export-guide'}, roles: ['ALL']},
        {title: 'About', icon: 'mdi-information', to: {name: 'about'}, roles: ['ALL']}
      ],
      profileItems: [
        {
          title: 'Profile',
          to: {
            name: 'profile'
          },
          icon: 'mdi-account-box',
          onClick: null
        },
        {
          title: 'Sign Out',
          to: null,
          icon: 'mdi-logout',
          onClick: this.signOut
        }
      ],
      loadingStatistic: true,
      accountStatistics: {},
    }
  },
  computed: {
    visibleMainMenuItems() {
      return this.mainMenuItems.filter(this.isAccessibleByRole)
    }
  },
  watch: {
    isAuthorized() {
      if (this.isAuthorized) {
        this.username = auth.getUsername()
        this.loadAccountStatistics()
      } else {
        this.username = null
      }
    }
  },
  mounted() {
    if (this.isAuthorized) {
      this.username = auth.getUsername()
      this.loadAccountStatistics()
    }
  },
  setup() {
    return {
      isAuthorized: inject('authorization').isAuthorized,
      switchAuthorizationState: inject('authorization').switchState,
      username: auth.getUsername()
    }
  },
  methods: {
    loadAccountStatistics() {
      const token = auth.getToken()
      if (token == null) {
        this.switchAuthorizationState()
        router.push({name: 'sign-in', state: {redirectTo: 'home'}})
        return
      }

      this.loadingStatistic = true
      api.getAccountStatistics(token, this.setAccountStatistics)
    },
    setAccountStatistics(response) {
      if (response?.data?.status === 'error') {
        return
      }

      this.loadingStatistic = false
      const statistics = response.data

      this.accountStatistics = statistics.balances.map((balance) => {
        return numbers.formatMoney(balance.balance_amount, balance.currency)
      })
    },
    signOut() {
      auth.signOut()
      this.switchAuthorizationState()
      router.push(this.signInRedirectionLink)
    },
    isAccessibleByRole(menuItem) {
      if (menuItem.roles.includes('ALL')) {
        return true
      }

      if (!this.isAuthorized) {
        return false
      }

      return auth.getRoles().some(role => menuItem.roles.includes(role))
    },
  }
}
</script>

<style scoped>

</style>